import CustomButton from './CustomButton'

const InfoModal = ({ isOpen, title, children, onClose, closeText = 'Cerrar' }) => {
  if (!isOpen) return null

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
      <div className='bg-white rounded-xl shadow-lg p-6 w-[400px]'>
        <h2 className='text-lg font-bold mb-4'>{title}</h2>
        <div className='mb-6 text-sm text-gray-700'>
          {children}
        </div>
        <div className='flex justify-end'>
          <CustomButton
            className='rounded-full'
            color='primary'
            onClick={onClose}
            title={closeText}
          />
        </div>
      </div>
    </div>
  )
}

export default InfoModal
